import { Typography, Box } from '@mui/material';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from './SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const contents = [
  '1) 插管時，因喉頭鏡與導管插入，可能造成嘴唇、牙齦、舌頭、咽喉、聲帶及氣管等損傷，並有牙齒斷裂的風險。',
  '2) 插管過程的刺激可能導致高血壓與心律不整。',
  '3) 對於無自主呼吸者，插管過久可能導致缺氧，進而造成嚴重的腦部與其他器官損傷。',
  '4) 因呼吸道刺激可能引起致命支氣管痙攣，插管過程中若吸入胃內容物，可能引發吸入性肺炎，嚴重時可能窒息。',
  '5) 插管後因分泌物堵塞或導管滑脫可能發生緊急情況，需立即再次插管處理。',
  '6) 插管後可能產生喉頭痙攣、喉嚨痛、喉頭水腫、聲帶麻痺、喉部肉芽腫、氣管狹窄等併發症。',
];
const Complications = (props: Props) => {
  return (
    <>
      <SectionTitle title="2. 手術後遺症或併發症" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '24px',
              whiteSpace: 'pre-wrap',
            }}
          >
            {v}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default Complications;
